// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sco-main-grid-item {
  display: flex;
  flex-direction: column !important;
  gap: 0.5vw;
}

/* ── Header typography ── */
.sco-select-header {
  font-size: 1.5vw !important;
  font-family: "Poppins" !important;
  font-weight: 500 !important;
  color: #000 !important;
}

.sco-select-header-create {
  font-size: 1.1vw !important;
  font-family: "Poppins" !important;
  font-weight: 500 !important;
  color: #000 !important;
}

/* ── Product card ── */
.sco-product-card {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  background: #1A1A1A;
  border-radius: 8px;
  padding: 0.8vw 0.9vw;
  gap: 0.8vw;
  min-height: 11vh;
}

.sco-product-info {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: 0.55vw;
  flex: 1 1;
  overflow: hidden;
}

.sco-product-row {
  display: flex;
  align-items: center;
  gap: 0.5vw;
  color: #fff;
  font-family: Karla;
  font-size: 0.95vw;
  font-weight: 400;
  white-space: nowrap;
}

.sco-product-style {
  font-family: Poppins;
  font-size: 1vw;
  font-weight: 600;
  color: #fff;
}

/* Force icon SVGs white inside dark card */
.sco-product-icon-wrap {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 1.1vw;
  height: 1.1vw;
}

.sco-product-icon-wrap svg {
  width: 100%;
  height: 100%;
}

.sco-product-icon-wrap svg path,
.sco-product-icon-wrap svg rect,
.sco-product-icon-wrap svg circle,
.sco-product-icon-wrap svg g {
  fill: #fff !important;
  stroke: #fff !important;
}

/* Product image */
.sco-product-img-wrap {
  width: 7.5vw;
  flex-shrink: 0;
  border-radius: 6px;
  overflow: hidden;
  background:#1A1A1A;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sco-product-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 6px;
}

.sco-product-img-placeholder {
  width: 7.5vw;
  min-height: 10vh;
  background:#1A1A1A;
  border-radius: 6px;
}

/* ── Label row (icon + text above each field) ── */
.sco-label-row {
  display: flex;
  align-items: center;
  gap: 0.45vw;
}

.sco-label-icon {
  font-size: 0.95vw;
  line-height: 1;
  color: #222;
  flex-shrink: 0;
}

/* ── Select / Dropdown ── */
.sco-select-field {
  width: 100% !important;
  height: 6.89vh !important;
  border: 1.5px solid #000 !important;
  border-radius: 5px !important;
  font-family: karla !important;
  font-size: 1.1vw !important;
  font-weight: 500 !important;
  color: #000 !important;
  background-color: #fff !important;
}

.sco-select-field .MuiOutlinedInput-notchedOutline {
  border: none !important;
}

.sco-select-field.Mui-focused .MuiOutlinedInput-notchedOutline {
  border: none !important;
}

.sco-select-field .MuiSelect-select {
  font-family: karla !important;
  font-size: 1.1vw !important;
  font-weight: 500 !important;
  color: #000 !important;
  padding-left: 0.8vw !important;
  display: flex !important;
  align-items: center !important;
}

.sco-select-field .MuiSelect-icon {
  color: #444 !important;
  right: 0.5vw !important;
}

.sco-placeholder {
  color: #888;
  font-family: karla;
  font-size: 1.1vw;
  font-weight: 400;
}

.sco-priority-standard {
  color: #50c878 !important;
  font-family: karla;
  font-size: 1.1vw;
  font-weight: 500;
}

/* ── Date input ── */
.sco-date-input {
  border: 1.5px solid #000 !important;
  width: 100% !important;
  height: 6.1vh !important;
  border-radius: 5px !important;
  outline: none !important;
  color: #000 !important;
  font-family: karla !important;
  font-weight: 500 !important;
  font-size: 1.1vw !important;
  cursor: pointer !important;
  padding-right: 0.2vw !important;
}

.sco-date-input .MuiOutlinedInput-notchedOutline {
  border: none !important;
}

.sco-date-input.Mui-focused .MuiOutlinedInput-notchedOutline {
  border: none !important;
}

.sco-date-input .MuiOutlinedInput-input {
  cursor: pointer !important;
  font-family: karla !important;
  font-size: 1.1vw !important;
  font-weight: 500 !important;
  color: #000 !important;
  padding-left: 0.8vw !important;
}

.sco-date-input .MuiOutlinedInput-input::placeholder {
  color: #888 !important;
  opacity: 1 !important;
  font-weight: 400 !important;
}

.sco-date-arrow {
  font-size: 1vw;
  color: #444;
  cursor: pointer;
  line-height: 1;
}

/* ── Comment textarea ── */
.sco-comment-box {
  height: 12vh;
  min-height: 6.3vh;
  max-height: 18vh;
  border-radius: 7px;
  color: #000 !important;
  font-family: Poppins !important;
  font-weight: 410 !important;
  font-size: 1.1vw !important;
  padding: 0.8vw;
  overflow: auto;
  scrollbar-width: none;
  resize: none;
  outline: none;
  border: 1.5px solid #1414140D;
  width: 100%;
  box-sizing: border-box;
  background: #1414140D;
}

.sco-comment-box::placeholder {
  color: #595959;
  font-family: Karla;
  font-size: 1.1vw;
  font-weight: 400;
}

.sco-comment-box:focus {
 
  background: #1414140D;
}


.sco-calendar-wrap {
  width: 100%;
  margin-top: 0.3vw;
}

.sco-cal-root {
  width: 100%;
}

.sco-cal-title {
  font-family: karla;
  font-size: 1vw;
  font-weight: 500;
  color: #50c878;
  margin-bottom: 0.5vw;
}

.sco-cal-card {
  background: #1A1A1A;
  border-radius: 8px;
  border: 1.5px solid #3a3a5c;
  padding: 1vw;
  width: 100%;
  box-sizing: border-box;
}

/* Month nav row */
.sco-cal-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.8vw;
}

.sco-cal-month-label {
  font-family: karla;
  font-size: 1.05vw;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 0.2vw;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.sco-cal-chevron {
  font-size: 0.9vw;
  color: #aaa;
}

.sco-cal-nav-btns {
  display: flex;
  gap: 0.3vw;
}

.sco-cal-nav-btn {
  background: transparent;
  border: 1px solid #3a3a5c;
  color: #fff;
  border-radius: 4px;
  width: 2vw;
  height: 2vw;
  font-size: 1.1vw;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transition: background 0.15s;
}

.sco-cal-nav-btn:hover {
  background: #2e2e44;
}

/* 7-column grid */
.sco-cal-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.15vw 0;
  border-top: 1px solid #3a3a5c;
  /* padding-top: 0.5vw; */
}

.sco-cal-day-header {
  font-family: karla;
  font-size: 0.85vw;
  font-weight: 500;
  color: #888;
  text-align: center;
  /* padding-bottom: 0.4vw; */
  border-bottom: 1px dotted #1A1A1A;
  margin-bottom: 0.15vw;
}

.sco-cal-day {
  background: transparent;
  border: none;
  color: #ccc;
  font-family: karla;
  font-size: 0.95vw;
  font-weight: 400;
  text-align: center;
  padding: 0.35vw 0;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  width: 100%;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sco-cal-day:hover:not(:disabled) {
  background: #2e2e44;
  color: #fff;
}

.sco-cal-day-empty {
  cursor: default;
  pointer-events: none;
  opacity: 0;
}

.sco-cal-day-today {
  background: #333355;
  color: #fff;
  font-weight: 600;
}

.sco-cal-day-selected {
  background: #fff !important;
  color: #000 !important;
  font-weight: 700;
}

.sco-cal-day:disabled {
  opacity: 0;
  pointer-events: none;
}

.sco-select-field .MuiTypography-root {
  color: #9e9e9e !important;
  font-weight: 400 !important;
}

.sco-select-field .MuiSelect-select {
  color: #000 !important;
}

.sco-date-input input::placeholder {
  color: #9e9e9e !important;
  opacity: 1 !important;
}
.sco-comment-box::placeholder {
  color: #9e9e9e !important;
  opacity: 1 !important;
}

.sco-date-input input {
  color: #000;
}

.sco-date-input input:placeholder-shown {
  color: #9e9e9e;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/CreateModal/createstockordermodal.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,iCAAiC;EACjC,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;EACX,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,mCAAmC;EACnC,sBAAsB;EACtB,wBAAwB;EACxB,6BAA6B;EAC7B,wBAAwB;EACxB,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,2BAA2B;EAC3B,2BAA2B;EAC3B,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;;AAGA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB","sourcesContent":["\n.sco-main-grid-item {\n  display: flex;\n  flex-direction: column !important;\n  gap: 0.5vw;\n}\n\n/* ── Header typography ── */\n.sco-select-header {\n  font-size: 1.5vw !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n  color: #000 !important;\n}\n\n.sco-select-header-create {\n  font-size: 1.1vw !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n  color: #000 !important;\n}\n\n/* ── Product card ── */\n.sco-product-card {\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n  background: #1A1A1A;\n  border-radius: 8px;\n  padding: 0.8vw 0.9vw;\n  gap: 0.8vw;\n  min-height: 11vh;\n}\n\n.sco-product-info {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  gap: 0.55vw;\n  flex: 1;\n  overflow: hidden;\n}\n\n.sco-product-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5vw;\n  color: #fff;\n  font-family: Karla;\n  font-size: 0.95vw;\n  font-weight: 400;\n  white-space: nowrap;\n}\n\n.sco-product-style {\n  font-family: Poppins;\n  font-size: 1vw;\n  font-weight: 600;\n  color: #fff;\n}\n\n/* Force icon SVGs white inside dark card */\n.sco-product-icon-wrap {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  width: 1.1vw;\n  height: 1.1vw;\n}\n\n.sco-product-icon-wrap svg {\n  width: 100%;\n  height: 100%;\n}\n\n.sco-product-icon-wrap svg path,\n.sco-product-icon-wrap svg rect,\n.sco-product-icon-wrap svg circle,\n.sco-product-icon-wrap svg g {\n  fill: #fff !important;\n  stroke: #fff !important;\n}\n\n/* Product image */\n.sco-product-img-wrap {\n  width: 7.5vw;\n  flex-shrink: 0;\n  border-radius: 6px;\n  overflow: hidden;\n  background:#1A1A1A;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sco-product-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  border-radius: 6px;\n}\n\n.sco-product-img-placeholder {\n  width: 7.5vw;\n  min-height: 10vh;\n  background:#1A1A1A;\n  border-radius: 6px;\n}\n\n/* ── Label row (icon + text above each field) ── */\n.sco-label-row {\n  display: flex;\n  align-items: center;\n  gap: 0.45vw;\n}\n\n.sco-label-icon {\n  font-size: 0.95vw;\n  line-height: 1;\n  color: #222;\n  flex-shrink: 0;\n}\n\n/* ── Select / Dropdown ── */\n.sco-select-field {\n  width: 100% !important;\n  height: 6.89vh !important;\n  border: 1.5px solid #000 !important;\n  border-radius: 5px !important;\n  font-family: karla !important;\n  font-size: 1.1vw !important;\n  font-weight: 500 !important;\n  color: #000 !important;\n  background-color: #fff !important;\n}\n\n.sco-select-field .MuiOutlinedInput-notchedOutline {\n  border: none !important;\n}\n\n.sco-select-field.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border: none !important;\n}\n\n.sco-select-field .MuiSelect-select {\n  font-family: karla !important;\n  font-size: 1.1vw !important;\n  font-weight: 500 !important;\n  color: #000 !important;\n  padding-left: 0.8vw !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.sco-select-field .MuiSelect-icon {\n  color: #444 !important;\n  right: 0.5vw !important;\n}\n\n.sco-placeholder {\n  color: #888;\n  font-family: karla;\n  font-size: 1.1vw;\n  font-weight: 400;\n}\n\n.sco-priority-standard {\n  color: #50c878 !important;\n  font-family: karla;\n  font-size: 1.1vw;\n  font-weight: 500;\n}\n\n/* ── Date input ── */\n.sco-date-input {\n  border: 1.5px solid #000 !important;\n  width: 100% !important;\n  height: 6.1vh !important;\n  border-radius: 5px !important;\n  outline: none !important;\n  color: #000 !important;\n  font-family: karla !important;\n  font-weight: 500 !important;\n  font-size: 1.1vw !important;\n  cursor: pointer !important;\n  padding-right: 0.2vw !important;\n}\n\n.sco-date-input .MuiOutlinedInput-notchedOutline {\n  border: none !important;\n}\n\n.sco-date-input.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border: none !important;\n}\n\n.sco-date-input .MuiOutlinedInput-input {\n  cursor: pointer !important;\n  font-family: karla !important;\n  font-size: 1.1vw !important;\n  font-weight: 500 !important;\n  color: #000 !important;\n  padding-left: 0.8vw !important;\n}\n\n.sco-date-input .MuiOutlinedInput-input::placeholder {\n  color: #888 !important;\n  opacity: 1 !important;\n  font-weight: 400 !important;\n}\n\n.sco-date-arrow {\n  font-size: 1vw;\n  color: #444;\n  cursor: pointer;\n  line-height: 1;\n}\n\n/* ── Comment textarea ── */\n.sco-comment-box {\n  height: 12vh;\n  min-height: 6.3vh;\n  max-height: 18vh;\n  border-radius: 7px;\n  color: #000 !important;\n  font-family: Poppins !important;\n  font-weight: 410 !important;\n  font-size: 1.1vw !important;\n  padding: 0.8vw;\n  overflow: auto;\n  scrollbar-width: none;\n  resize: none;\n  outline: none;\n  border: 1.5px solid #1414140D;\n  width: 100%;\n  box-sizing: border-box;\n  background: #1414140D;\n}\n\n.sco-comment-box::placeholder {\n  color: #595959;\n  font-family: Karla;\n  font-size: 1.1vw;\n  font-weight: 400;\n}\n\n.sco-comment-box:focus {\n \n  background: #1414140D;\n}\n\n\n.sco-calendar-wrap {\n  width: 100%;\n  margin-top: 0.3vw;\n}\n\n.sco-cal-root {\n  width: 100%;\n}\n\n.sco-cal-title {\n  font-family: karla;\n  font-size: 1vw;\n  font-weight: 500;\n  color: #50c878;\n  margin-bottom: 0.5vw;\n}\n\n.sco-cal-card {\n  background: #1A1A1A;\n  border-radius: 8px;\n  border: 1.5px solid #3a3a5c;\n  padding: 1vw;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Month nav row */\n.sco-cal-nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.8vw;\n}\n\n.sco-cal-month-label {\n  font-family: karla;\n  font-size: 1.05vw;\n  font-weight: 600;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  gap: 0.2vw;\n  cursor: pointer;\n  user-select: none;\n}\n\n.sco-cal-chevron {\n  font-size: 0.9vw;\n  color: #aaa;\n}\n\n.sco-cal-nav-btns {\n  display: flex;\n  gap: 0.3vw;\n}\n\n.sco-cal-nav-btn {\n  background: transparent;\n  border: 1px solid #3a3a5c;\n  color: #fff;\n  border-radius: 4px;\n  width: 2vw;\n  height: 2vw;\n  font-size: 1.1vw;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  transition: background 0.15s;\n}\n\n.sco-cal-nav-btn:hover {\n  background: #2e2e44;\n}\n\n/* 7-column grid */\n.sco-cal-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 0.15vw 0;\n  border-top: 1px solid #3a3a5c;\n  /* padding-top: 0.5vw; */\n}\n\n.sco-cal-day-header {\n  font-family: karla;\n  font-size: 0.85vw;\n  font-weight: 500;\n  color: #888;\n  text-align: center;\n  /* padding-bottom: 0.4vw; */\n  border-bottom: 1px dotted #1A1A1A;\n  margin-bottom: 0.15vw;\n}\n\n.sco-cal-day {\n  background: transparent;\n  border: none;\n  color: #ccc;\n  font-family: karla;\n  font-size: 0.95vw;\n  font-weight: 400;\n  text-align: center;\n  padding: 0.35vw 0;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n  width: 100%;\n  aspect-ratio: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sco-cal-day:hover:not(:disabled) {\n  background: #2e2e44;\n  color: #fff;\n}\n\n.sco-cal-day-empty {\n  cursor: default;\n  pointer-events: none;\n  opacity: 0;\n}\n\n.sco-cal-day-today {\n  background: #333355;\n  color: #fff;\n  font-weight: 600;\n}\n\n.sco-cal-day-selected {\n  background: #fff !important;\n  color: #000 !important;\n  font-weight: 700;\n}\n\n.sco-cal-day:disabled {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.sco-select-field .MuiTypography-root {\n  color: #9e9e9e !important;\n  font-weight: 400 !important;\n}\n\n.sco-select-field .MuiSelect-select {\n  color: #000 !important;\n}\n\n.sco-date-input input::placeholder {\n  color: #9e9e9e !important;\n  opacity: 1 !important;\n}\n.sco-comment-box::placeholder {\n  color: #9e9e9e !important;\n  opacity: 1 !important;\n}\n\n.sco-date-input input {\n  color: #000;\n}\n\n.sco-date-input input:placeholder-shown {\n  color: #9e9e9e;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
